export const firebaseTimestampToDate = (timestamp) => new Date(timestamp.seconds * 1000);
export const getYearsFromEntries = (entries) =>
  Array.from(new Set(entries.map((item) => firebaseTimestampToDate(item.completedDate).getFullYear())));
